import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="job-announcement-form"
export default class extends Controller {
  static targets = ["selectAll", "selectedText"]
  static values = {
    usersCount: Number
  }
  
  updateSelectedText(e) {
    let selectedCount = this.element.querySelectorAll('input[type="checkbox"]:checked').length;
    if (this.selectAllTarget.checked) {
      selectedCount = selectedCount - 1;
    }
    this.dispatchUsersSelected({ original_target: e.target });

    this.selectedTextTarget.textContent = `(${selectedCount} selected)`;
  }

  maybeSelectAll() {
    if (this.selectAllTarget.checked) {
      this.selectAll();
    }
  }

  selectAll() {
    const userCheckboxes = this.element.querySelectorAll("tbody input[type=\"checkbox\"]")

    if (this.selectAllTarget.checked) {
      userCheckboxes.forEach((checkbox) => {
        checkbox.checked = true
      })
      this.selectedTextTarget.textContent = `(${this.usersCountValue} selected)`
    } else {
      userCheckboxes.forEach((checkbox) => {
        checkbox.checked = false
      })
      this.selectedTextTarget.textContent = "(0 selected)"
    }

    this.dispatchUsersSelected({
      bulk: true,
      select_all_checked: this.selectAllTarget.checked
    })
  }

  dispatchUsersSelected(detail) {
    const form = this.element.closest("form")
    if (form) {
      form.dispatchEvent(new CustomEvent("users-selected", { detail }))
    }
  }
}
